// extracted by mini-css-extract-plugin
module.exports = {"imageHero":"customer-review_imageHero__mtNvu","reviewCard":"customer-review_reviewCard__FRtc7"};